
import { defineComponent } from 'vue'
export default defineComponent({
  setup () {
    return {
      message: '404 Page Not Found'
    }
  }
})
